
import { Vue, Component } from 'vue-property-decorator';
import Api from '@/services/api';

@Component
export default class WalletPayment extends Vue {
  public formTitle = 'گزارش پرداخت ها';
  public desserts = [];
  public headers = [
    { text: 'شماره پیگیری', value: 'id' },
    { text: 'تاریخ', value: 'paymentDate' },
    { text: 'مبلغ', value: 'amount' },
    { text: 'شماره پیگیری بانک', value: 'rrn' },
    { text: 'شماره کارت', value: 'hashCardNumber' },
    { text: 'وضعیت', value: 'paymentStatus' },
    { text: 'نام درگاه', value: 'paymentProvider' },
    { text: '', value: 'action', sortable: false }
  ];
  public breadcrumbItems = [
    {
      text: 'صفحه اصلی',
      disabled: false,
      href: '/'
    },
    {
      text: 'گزارش پرداخت ها',
      disabled: true,
      href: ''
    }
  ];

  async created() {
    await this.initialize();
  }

  async initialize() {
    this.$showLoading();
    await Api.getWalletPayments().then((response: any) => {
      this.desserts = response.data;
      this.$hideLoading();
    });
  }

  async close() {
    await this.initialize();
  }

  formatPrice(value: number) {
    const val = (value / 1).toFixed(0).replace('.', ',');
    return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  getColor(paymentStatus: string) {
    if (paymentStatus === 'پرداخت شده') {
      return 'green lighten-2';
    } else {
      return 'red lighten-1';
    }
  }
}
